import React from 'react';
import { RecaptchaNotice } from '../../../../../components/ReCaptchaContainer';
import { useRegisterComponent } from '../../../../orchestrator';

export const WelcomeRecaptchaNotice = () => {
  useRegisterComponent(WelcomeRecaptchaNotice.name);
  return <RecaptchaNotice />;
};
